export enum FeatureGateBannerQuotaLevel {
  Warning = "warning",
  Exceeded = "exceeded",
}

export interface FeatureGateBannerProps {
  level?: FeatureGateBannerQuotaLevel;
}
